module.exports = __webpack_public_path__ + "static/media/bakery-dessert-donut-svgrepo-com.be23b821.svg";